/**
 * Версії моделі та схеми експорту — додаються в JSON/Markdown/HTML звіти.
 * Оновлюй COEFFICIENTS_LAST_UPDATED при зміні коефіцієнтів у costEngine / регіонах.
 */
export const MODEL_VERSION = "1.1.0";
/** Логічна версія payload сценарію (паралельно до v у JSON bundle). */
export const SCHEMA_VERSION = "2";
export const COEFFICIENTS_LAST_UPDATED = "2026-04-04";

export const REFERENCE_LINKS: readonly {
  href: string;
  labelKey: "trust.link.calculator" | "trust.link.pricing" | "trust.link.docs";
}[] = [
  {
    href: "https://calculator.aws/",
    labelKey: "trust.link.calculator",
  },
  {
    href: "https://aws.amazon.com/pricing/",
    labelKey: "trust.link.pricing",
  },
  {
    href: "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-what-is.html",
    labelKey: "trust.link.docs",
  },
] as const;

/** Індикативний курс для відображення EUR (модель лишається в USD). */
export const USD_PER_EUR_INDICATIVE = 1 / 0.92;
